import React, { useState, useEffect } from 'react';
import { Button, Box, TextField, Typography,
    Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper
 } from '@mui/material';
import { useAuth } from 'context/UseContext';

const ChatPage = () => {
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const DEFAULT_WEBHOOK =
        "https://warrant-pill-labs-templates.trycloudflare.com/webhook/fe33fc56-7b26-4c58-a523-773d78c4e364/chat";

    const [webhookUrl, setWebhookUrl] = useState(() => {
        return localStorage.getItem("chat_webhook_url") || DEFAULT_WEBHOOK;
    });

    const { user } = useAuth();

    const userId = user?.id;
    const route = "general";

    const themeToggle = () => {
        setIsDarkMode(prev => !prev);
    };



     const extractColumnsAndRows = (items) => {
    const columns = [];
    const rows = [];

    items.forEach(item => {
        const parts = item.split(" – ").map(p => p.trim());
        const row = [];

        parts.forEach(part => {
            let label = "";
            let value = "";

            if (part.includes(":")) {
                const splitIndex = part.indexOf(":");
                label = part.slice(0, splitIndex).trim();
                value = part.slice(splitIndex + 1).trim();
            } else {
                const tokens = part.split(" ");
                label = tokens[0] + (tokens[1] ? " " + tokens[1] : "");
                value = tokens.slice(2).join(" ");
            }

            const normalizedLabel = label
                .replace(/\*\*/g, "")
                .replace(/\s+/g, " ")
                .trim();

            if (!columns.includes(normalizedLabel)) {
                columns.push(normalizedLabel);
            }

            row.push(value || part);
        });

        rows.push(row);
    });

    return { columns, rows };
};



// const parseAITextResponse = (text) => {
//     if (!text || typeof text !== "string") {
//         return { type: "text", content: "" };
//     }

//     const lines = text
//         .split("\n")
//         .map(l => l.trim())
//         .filter(Boolean);

//     const listLines = lines.filter(l => l.startsWith("- "));
//     const titleLines = lines.filter(l => !l.startsWith("- "));

//     if (listLines.length >= 2) {
//         const cleanedItems = listLines.map(l =>
//             l.replace("- ", "").replace(/\*\*/g, "")
//         );

//         const splitRows = cleanedItems.map(row =>
//             row.split(" – ").map(c => c.trim())
//         );

//         const colCount = splitRows[0].length;
//         const isTable = splitRows.every(r => r.length === colCount);

//         if (isTable && colCount >= 3) {
//             const columns = splitRows[0].map(col =>
//                 col.split(" ")[0]
//             );

//             return {
//                 type: "table",
//                 title: titleLines.join(" "),
//                 columns,
//                 rows: splitRows
//             };
//         }

//         return {
//             type: "ordered_list",
//             title: titleLines.join(" "),
//             items: cleanedItems
//         };
//     }

//     return {
//         type: "text",
//         content: text.replace(/\*\*/g, "")
//     };
// };


const parseAITextResponse = (text) => {
    if (!text || typeof text !== "string") {
        return { type: "text", content: "" };
    }

    const lines = text
        .split("\n")
        .map(l => l.trim())
        .filter(Boolean);

    const listLines = lines.filter(l => l.startsWith("- "));
    const titleLines = lines.filter(l => !l.startsWith("- "));

    if (listLines.length >= 1) {
        const cleanedItems = listLines.map(l =>
            l.replace("- ", "").replace(/\*\*/g, "")
        );

        const splitItems = cleanedItems.map(item =>
            item.split(" – ").map(p => p.trim())
        );

        const maxParts = Math.max(...splitItems.map(i => i.length));

        // Decision logic
        const shouldBeTable =
            cleanedItems.length > 1 && maxParts > 1;

        if (shouldBeTable) {
            const columnCount = splitItems[0].length;
            const isConsistent = splitItems.every(
                row => row.length === columnCount
            );

            if (isConsistent) {
                const columns = splitItems[0].map((cell, index) => {
                    const words = cell.split(" ");
                    return words.length > 1
                        ? words.slice(0, 2).join(" ")
                        : `Column ${index + 1}`;
                });

                return {
                    type: "table",
                    title: titleLines.join(" "),
                    columns,
                    rows: splitItems
                };
            }
        }

        return {
            type: "ordered_list",
            title: titleLines.join(" "),
            items: cleanedItems
        };
    }

    return {
        type: "text",
        content: text.replace(/\*\*/g, "")
    };
};




    // const renderBotMessage = (payload) => {
    //     if (!payload) return null;

    //     if (payload.type === "text") {
    //         return <Typography>{payload.content}</Typography>;
    //     }

    //     if (payload.type === "unordered_list") {
    //         return (
    //             <Box>
    //                 {payload.title && (
    //                     <Typography fontWeight={600} sx={{ mb: 1 }}>
    //                         {payload.title}
    //                     </Typography>
    //                 )}
    //                 <ul style={{ paddingLeft: "20px", margin: 0 }}>
    //                     {payload.items.map((item, index) => (
    //                         <li key={index}>
    //                             <Typography>{item}</Typography>
    //                         </li>
    //                     ))}
    //                 </ul>
    //             </Box>
    //         );
    //     }

    //     return <Typography>Unsupported response</Typography>;
    // };


   const renderBotMessage = (payload) => {
    if (!payload) return null;

    if (payload.type === "text") {
        return <Typography>{payload.content}</Typography>;
    }

    if (payload.type === "ordered_list") {
    return (
        <Box>
            {payload.title && (
                <Typography fontWeight={600} sx={{ mb: 1 }}>
                    {payload.title}
                </Typography>
            )}
            <Box>
                {payload.items.map((item, index) => (
                    <Box
                        key={index}
                        sx={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "flex-start",
                            mb: 0.5
                        }}
                    >
                        <Typography fontWeight={600}>
                            {index + 1}.
                        </Typography>
                        <Typography>{item}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}


    if (payload.type === "table") {
        return (
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            {payload.columns.map((col, i) => (
                                <TableCell key={i} sx={{ fontWeight: 600 }}>
                                    {col}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payload.rows.map((row, i) => (
                            <TableRow key={i}>
                                {row.map((cell, j) => (
                                    <TableCell key={j}>{cell}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    return null;
};


    const handleSend = async () => {
        if (!inputValue.trim()) return;

        const userMessage = inputValue;
        const combinedMessage = `Customer id 0001 - ${userMessage}`;
        setMessages(prevMessages => [
            ...prevMessages,
            { sender: 'user', userId, text: userMessage },
        ]);

        setInputValue('');
        setIsTyping(true);

        const chatId = `chat_${Math.random().toString(36).substr(2, 9)}`;
        const payload = {
            chatId: chatId,
            message: combinedMessage,
            route: route,
        };

        try {
            const response = await fetch(webhookUrl, { // Use the dynamic webhook URL
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            const structuredPayload = parseAITextResponse(data.output);

            console.log(data?.output?.type, data?.output, 'type of response.......')

            setIsTyping(false);
            setMessages(prevMessages => [
                ...prevMessages,
                { sender: 'bot', text: structuredPayload || "A processing issue occurred. Please try again." },
            ]);
        } catch (error) {
            setIsTyping(false);
            setMessages(prevMessages => [
                ...prevMessages,
                { sender: 'bot', text: "A system or network issue occurred. Please try again later." },
            ]);
        }
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSend();
        }
    };

    const handleWebhookUrlChange = (event) => {
        setWebhookUrl(event.target.value);
    };

    useEffect(() => {
        if (webhookUrl) {
            localStorage.setItem("chat_webhook_url", webhookUrl);
        }
    }, [webhookUrl]);



    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100vh',
                backgroundColor: isDarkMode ? '#121212' : '#f5f5f5',
                color: isDarkMode ? '#e0e0e0' : '#1b1b1b',
                transition: '0.3s all',
            }}
        >
            <Box
                sx={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 24px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    backgroundColor: isDarkMode ? '#5bbc0f' : '#358437 ',
                    color: 'white',
                }}
            >
                <Typography variant="h6">Chat</Typography>
                <Button
                    sx={{
                        background: 'rgba(255,255,255,0.2)',
                        border: 'none',
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                    }}
                    onClick={themeToggle}
                >
                    {isDarkMode ? 'Light' : 'Dark'}
                </Button>
            </Box>

            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                {messages.map((msg, index) => (
                    <Box
                        key={index}
                        sx={{
                            maxWidth: '70%',
                            padding: '14px 18px',
                            borderRadius: '12px',
                            fontSize: '15px',
                            lineHeight: '1.5',
                            wordWrap: 'break-word',
                            alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                            backgroundColor: msg.sender === 'user' ? (isDarkMode ? '#333333' : '#e0e0e0') : (isDarkMode ? '#5bbc0f' : '#358437'),
                            color: msg.sender === 'user' ? (isDarkMode ? '#e0e0e0' : '#1b1b1b') : 'white',
                            animation: 'fadeIn 0.2s ease',
                        }}
                    >
                        {msg.sender === 'user' && <strong>{msg.userId}: </strong>}
                        {msg.sender === "bot"
                            ? renderBotMessage(msg.text)
                            : msg.text}
                        {/* {msg.text} */}
                    </Box>
                ))}
                {isTyping && (
                    <Box
                        sx={{
                            alignSelf: 'flex-start',
                            background: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                            width: '60px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '10px 12px',
                            borderRadius: '12px',
                            fontSize: '0',
                            animation: 'fadeIn 0.2s ease',
                        }}
                    >
                        <span
                            sx={{
                                width: '8px',
                                height: '8px',
                                background: isDarkMode ? '#eee' : '#eee',
                                borderRadius: '50%',
                                animation: 'blink 1s infinite',
                            }}
                        ></span>
                        <span
                            sx={{
                                width: '8px',
                                height: '8px',
                                background: isDarkMode ? '#eee' : '#eee',
                                borderRadius: '50%',
                                animation: 'blink 1s infinite',
                                animationDelay: '0.2s',
                            }}
                        ></span>
                        <span
                            sx={{
                                width: '8px',
                                height: '8px',
                                background: isDarkMode ? '#eee' : '#555',
                                borderRadius: '50%',
                                animation: 'blink 1s infinite',
                                animationDelay: '0.4s',
                            }}
                        ></span>
                    </Box>
                )}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    padding: '14px 20px',
                    gap: '12px',
                    borderTop: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                }}
            >
                <TextField
                    sx={{
                        flex: 1,
                        padding: '14px',
                        borderRadius: '12px',
                        border: '1px solid #ccc',
                        fontSize: '15px',
                        outline: 'none',
                    }}
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}

                    placeholder="Type your message..."
                />

                <Button
                    sx={{
                        backgroundColor: isDarkMode ? '#5bbc0f' : '#358437 ',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '10px 12px',
                        fontWeight: '600',
                        cursor: 'pointer',
                    }}
                    onClick={handleSend}
                >
                    Send
                </Button>
            </Box>

            {/* New section for updating webhook URL */}
            <Box
                sx={{
                    padding: '10px 20px',
                    backgroundColor: isDarkMode ? '#333333' : '#f5f5f5',
                    borderTop: '1px solid #ccc',
                }}
            >
                <Typography variant="body1">Update Webhook URL</Typography>
                <TextField
                    fullWidth
                    value={webhookUrl}
                    onChange={handleWebhookUrlChange}
                    sx={{
                        marginTop: '8px',
                        padding: '10px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                    }}
                    placeholder="Enter new webhook URL"
                />
                <Button
                    sx={{
                        marginTop: '10px',
                        backgroundColor: '#358437',
                        color: 'white',
                        padding: '6px 12px',
                        borderRadius: '6px',
                    }}
                    onClick={() => alert('Webhook URL updated!')}
                >
                    Update URL
                </Button>
            </Box>
        </Box>
    );
};

export default ChatPage;
